import * as React from 'react';
import { PublicPageWrapper } from '../../../_pageWrappers/PublicPageWrapper';
import { LearningModuleContent } from '../../../_components/learning/LearningModuleContent';

export function LearningModulePublicPage (): JSX.Element
{
    return (
        <PublicPageWrapper partner='Joblife'>
            <LearningModuleContent isPublic />
        </PublicPageWrapper>
    );
}